module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-box"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.sending || _vm.loading
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "c-box__heading",
    on: {
      "click": function($event) {
        return _vm.toggleProductInfo()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "u-floatRight",
    class: _vm.toggleIconClass()
  }), _vm._v(" "), (_vm.productStatus && _vm.productStatus !== 'sending') ? _c('span', {
    staticClass: "badge u-floatRight status",
    class: _vm.productStatus,
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t((_vm.productStatus + ".label"))))]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "c-box__body"
  }, [_c('div', {
    staticClass: "c-box__inner"
  }, [_c('general-main', {
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), _c('general-category', {
    attrs: {
      "product": _vm.product
    },
    on: {
      "change": _vm.clearInfos,
      "searchCategoryInfo": _vm.searchCategoryInfo,
      "loading": _vm.isLoader
    }
  }), _vm._v(" "), (_vm.infos.settings && !_vm.loading) ? _c('general-details', {
    attrs: {
      "product": _vm.product,
      "category": _vm.infos,
      "announcementConfigurations": _vm.announcementConfigurations,
      "defaultTypeCheckout": _vm.typeCheckout
    },
    on: {
      "changeTypeCheckout": function (v) { return _vm.typeCheckout = v; }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isUseVariationCombination) ? _c('panel', {
    attrs: {
      "title": "Tipo de Variação"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Tipo",
      "columns": 12,
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variationsCombination),
      expression: "variationsCombination"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.variationsCombination = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.infos.variations_combinations), function(variationCombination) {
    return _c('option', {
      key: variationCombination,
      domProps: {
        "value": variationCombination.id
      }
    }, [_vm._v(_vm._s(variationCombination.name))])
  })], 2)])], 1)]) : _vm._e(), _vm._v(" "), ((_vm.infos.attributes.length && !_vm.isUseVariationCombination) || (_vm.variationsCombination !== null && _vm.isUseVariationCombination)) ? _c('panel', {
    attrs: {
      "title": "Atributos"
    }
  }, [_c('general-attributes', {
    attrs: {
      "product": _vm.product,
      "attributes": _vm.infos.attributes,
      "announcementConfigurations": _vm.announcementConfigurations
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('fiscal-attributes', {
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), ((_vm.infos.settings && !_vm.isUseVariationCombination) || (_vm.variationsCombination !== null && _vm.isUseVariationCombination)) ? _c('product-edit-bulk-price', {
    attrs: {
      "fromModule": _vm.fromModule,
      "product": _vm.product
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.infos.settings && !_vm.isUseVariationCombination) || (_vm.variationsCombination !== null && _vm.isUseVariationCombination)) ? _c('variation', {
    attrs: {
      "product": _vm.product,
      "category": _vm.infos,
      "fromModule": _vm.fromModule,
      "typeCheckout": _vm.typeCheckout
    },
    on: {
      "changeTypeCheckout": function (v) { return _vm.typeCheckout = v; }
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.product.title))])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abf2a752","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/Product.vue
// module id = 3396
// module chunks = 0